export const SHUFFLE_MAPPER: Record<number, number | string> = {
  0: 7,
  1: 'E',
  2: 'B',
  3: 0,
  4: 2,
};
